function init() {  
   
   
    const productForms = document.querySelectorAll('[action^="/cart/add"]');

    productForms.forEach(form => {
      const sellingPlanContainer = document.createElement("input");
      sellingPlanContainer.id = "selling_plan";
      sellingPlanContainer.className = "gsa_selling_plan";
      sellingPlanContainer.type = "hidden";
      sellingPlanContainer.setAttribute("name", "selling_plan");
      sellingPlanContainer.value = "";
   
      form.appendChild(sellingPlanContainer.cloneNode());
    });

    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });


    // -------------- ALTERNATIVE ------------
    const productFormsButtons = document.querySelectorAll('[action^="/cart/add"]');

    productFormsButtons.forEach(form => {
      const buttons = form.querySelectorAll('button'); // Select all buttons within the form

      buttons.forEach(button => {
        // Add the event listener to each button
        button.addEventListener('click', function (event) {
          let variantInput = document.querySelector('[name="id"]');
          let spoofVariantInput = document.querySelector('[name="gsa-variant"]');
          let spoofVariantValue = spoofVariantInput.value;

          event.preventDefault(); // prevent the form from submitting
          variantInput.value = spoofVariantValue; // update the value of the input element
          // submit the form programmatically if needed
          // form.submit();
        });
      });
    });

    const currentProductList = productList;
    let lastSubscriptionPosition = 0;

    const mapSellingPlan = (currentVariantId, subscriptionPosition) => {
      let currentVariantTitle = '';

      if (subscriptionPosition === null) {
          lastSubscriptionPosition = lastSubscriptionPosition;
      } else {
          lastSubscriptionPosition = subscriptionPosition;
      }

      console.log("MAP TO THIS ID: " + currentVariantId);
      console.log("SUBSCRIPTION POSITION: " + lastSubscriptionPosition);

      const purchaseOptions = document.getElementsByName('purchase_options');
      for(let x = 0; x <  purchaseOptions.length; x++) {

        let currentProduct = currentProductList[x].variants;

        for (let i = 0; i < currentProduct.length; i++) {
          if (currentProduct[i].id == currentVariantId) {
              currentVariantTitle = currentProduct[i].title;
              console.log("CURRENT VARIANT TITLE CONSOLE: " + currentVariantTitle);
              break;

          }
        }

      }

      updateVariantID(currentVariantTitle);

      objectionBuster(lastSubscriptionPosition);

    }

    const updateVariantID = (currentVariantTitle) => {
      const currentProduct = currentProductList[lastSubscriptionPosition].variants;

      for (let i = 0; i < currentProduct.length; i++) {
        if (currentProduct[i].title == currentVariantTitle) {
            let selectedVariantId = currentProduct[i].id;
            let spoofVariantInput = document.querySelector('[name="gsa-variant"]');
            spoofVariantInput.value = selectedVariantId;
            console.log(selectedVariantId);
            break;

        }
      }

      updateSubscriptionPrice(currentVariantTitle);

    }

    const updateSubscriptionPrice = (currentVariantTitle) => {
      for(let x = 0; x <  currentProductList.length; x++) {
        let currentProduct = currentProductList[x].variants;
        for (let i = 0; i < currentProduct.length; i++) {
          if (currentProduct[i].title == currentVariantTitle) {
              let variantPrice = currentProduct[i].selling_plan_allocations[0].price;
              let setSubscriptionPrice = formatter.format((variantPrice / 100).toFixed(2));
              let subscriptionPriceElements = document.getElementsByClassName("subscription-price");
              subscriptionPriceElements[x].innerText = setSubscriptionPrice;
              console.log([x]);
              console.log(variantPrice);
          }
        }
      }
    }

    const objectionBuster = (lastSubscriptionPosition) => {
        console.log("INIATE OBJECTION BUSTER");

        const firstObjectionBuster = document.getElementById("gsa-first-objection-buster");
        const secondObjectionBuster = document.getElementById("gsa-second-objection-buster");
        if (lastSubscriptionPosition == 0) {
            if (firstObjectionBuster) {
                console.log("FIRST");
                firstObjectionBuster.style.display = "block";
                secondObjectionBuster.style.display = "none";
            }
        } else {
            if (firstObjectionBuster) {
                console.log("OTHER");
                firstObjectionBuster.style.display = "none";
                secondObjectionBuster.style.display = "block";
            }
        }
    }

    class SellingPlan extends HTMLElement {
        constructor() {
            super();
            this.addEventListener("change", this.onSellingPlanChange);
            window.addEventListener("load", this.initialLoad);
        }

        initialLoad() {
            const variantElement = document.querySelector("selling-plan-selector");        
            const boundHandlePageLoad = handlePageLoad.bind(variantElement);
            boundHandlePageLoad();
            function handlePageLoad() {

                let variantSelector = document.querySelector('[name="id"]');
                const initialVariantID = variantSelector.value;
                const getVariantList = productData.variants;

                console.log(getVariantList);

                for (let i = 0; i < getVariantList.length; i++) {
                    // code to check for ID match and output title
                    console.log(getVariantList[i].id);

                    if (getVariantList[i].id == initialVariantID) {

                        console.log(getVariantList[i].title);

                        this.currentVariantTitle = getVariantList[i].title;

                        this.initialLoadConfig = true;
                        break;
                        // code to output title
                    }
                }

                this.onSellingPlanChange();
            }
        }

        onSellingPlanChange() {
            this.getSelectedVariant();
            this.getPurchaseOptionPosition();
            this.getSelectedTitles();
            this.mapVariant();
            this.updatevariantID();
            this.updateSellingPlan();
        }


        getPrepaidJSON() {
            this.prepaidData = this.productData || productList;
            return this.prepaidData;
        }

        getPurchaseOptionPosition() {
            this.purchaseOptions = document.getElementsByName('purchase_options');
            for(let x = 0; x <  this.purchaseOptions.length; x++) {
                if( this.purchaseOptions[x].checked) {
                    console.log(this.purchaseOptions[x]);
                    console.log([x]);
                    this.optionPosition = [x];
                }
            }

        }

        getSelectedVariant() {
            console.log("VARIANT CHANGED");
            let variantSelector = document.querySelector('[name="id"]');
            this.selectedVariantId = variantSelector.value;
        }

        getSelectedTitles() {
          if(this.initialLoadConfig == true) {
            console.log("TRUE");

            this.initialLoadConfig = false;
          } else {
            console.log("FALSE");
            const currentProductList = this.prepaidData;

            console.log("SELECTED VARIANT: " + this.selectedVariantId);

            this.purchaseOptions = document.getElementsByName('purchase_options');
            for(let x = 0; x <  this.purchaseOptions.length; x++) {

              let currentProduct = currentProductList[x].variants;
              console.log(currentProduct);

              for (let i = 0; i < currentProduct.length; i++) {
                if (currentProduct[i].id == this.selectedVariantId) {
                    this.currentVariantTitle = currentProduct[i].title;
                    console.log(this.currentVariantTitle);
                    break;

                }
              }

            }

          }

        }

        mapVariant() {
            this.getPrepaidJSON();
            const currentProductList = this.prepaidData;
       
            const currentProduct = currentProductList[this.optionPosition].variants;

            console.log("MAPPING TITLE:");  
            console.log(this.currentVariantTitle);  
            console.log(currentProduct);

            for (let i = 0; i < currentProduct.length; i++) {
              if (currentProduct[i].title == this.currentVariantTitle) {
                  this.selectedVariantId = currentProduct[i].id;
                  this.selectedSellingPlanID = currentProduct[i].selling_plan_allocations[0].selling_plan_id;

                  console.log("NEW VARIANT ID: " + this.selectedVariantId);
                  console.log("NEW SELLING_PLAN ID: " + this.selectedSellingPlanID);

                  break;

              }
            }
        }

        updatevariantID() {
          let variantInput = document.querySelector('[name="gsa-variant"]');
          variantInput.value = this.selectedVariantId;
          console.log(variantInput);
        }

        updateSellingPlan() {
            console.log("UPDATE SELLING PLAN");
            const sellingPlanContainers = document.querySelectorAll("#selling_plan");
           
            sellingPlanContainers.forEach(container => {
                container.value = this.selectedSellingPlanID;
            });

            this.updateMappingLogic();
        }

        updateMappingLogic() {
            let currentVariantId = this.selectedVariantId;
            let subscriptionPosition = this.optionPosition;
            const boundHandlePageLoadTest = handlePageLoadTest.bind(window);
            boundHandlePageLoadTest();
            function handlePageLoadTest() {
                mapSellingPlan(currentVariantId, subscriptionPosition);
            }
        }

    }

    customElements.define("selling-plan-selector", SellingPlan);

    let variantSelector = document.querySelector('[name="id"]');
    let currentVariantId = variantSelector.value;

    variantSelector.addEventListener('change', function() {
      // Get the new variant ID
      let newVariantId = variantSelector.value;
      let optionPosition = null;
      // Check if the variant has changed
      if (newVariantId !== currentVariantId) {
          currentVariantId = newVariantId;
          mapSellingPlan(currentVariantId, optionPosition);
      }
    });
}

if (document.readyState === "loading") {
   document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}